import { __exports as constructors } from "../../../../../../../_virtual/constructors.js";
import { __require as requireAttribute } from "./attribute.js";
import { __require as requireClassName } from "./className.js";
import { __require as requireCombinator } from "./combinator.js";
import { __require as requireComment } from "./comment.js";
import { __require as requireId } from "./id.js";
import { __require as requireNesting } from "./nesting.js";
import { __require as requirePseudo } from "./pseudo.js";
import { __require as requireRoot } from "./root.js";
import { __require as requireSelector } from "./selector.js";
import { __require as requireString } from "./string.js";
import { __require as requireTag } from "./tag.js";
import { __require as requireUniversal } from "./universal.js";
var hasRequiredConstructors;
function requireConstructors() {
  if (hasRequiredConstructors) return constructors;
  hasRequiredConstructors = 1;
  constructors.__esModule = true;
  constructors.universal = constructors.tag = constructors.string = constructors.selector = constructors.root = constructors.pseudo = constructors.nesting = constructors.id = constructors.comment = constructors.combinator = constructors.className = constructors.attribute = void 0;
  var _attribute = _interopRequireDefault(requireAttribute());
  var _className = _interopRequireDefault(requireClassName());
  var _combinator = _interopRequireDefault(requireCombinator());
  var _comment = _interopRequireDefault(requireComment());
  var _id = _interopRequireDefault(requireId());
  var _nesting = _interopRequireDefault(requireNesting());
  var _pseudo = _interopRequireDefault(requirePseudo());
  var _root = _interopRequireDefault(requireRoot());
  var _selector = _interopRequireDefault(requireSelector());
  var _string = _interopRequireDefault(requireString());
  var _tag = _interopRequireDefault(requireTag());
  var _universal = _interopRequireDefault(requireUniversal());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var attribute = function attribute2(opts) {
    return new _attribute["default"](opts);
  };
  constructors.attribute = attribute;
  var className = function className2(opts) {
    return new _className["default"](opts);
  };
  constructors.className = className;
  var combinator = function combinator2(opts) {
    return new _combinator["default"](opts);
  };
  constructors.combinator = combinator;
  var comment = function comment2(opts) {
    return new _comment["default"](opts);
  };
  constructors.comment = comment;
  var id = function id2(opts) {
    return new _id["default"](opts);
  };
  constructors.id = id;
  var nesting = function nesting2(opts) {
    return new _nesting["default"](opts);
  };
  constructors.nesting = nesting;
  var pseudo = function pseudo2(opts) {
    return new _pseudo["default"](opts);
  };
  constructors.pseudo = pseudo;
  var root = function root2(opts) {
    return new _root["default"](opts);
  };
  constructors.root = root;
  var selector = function selector2(opts) {
    return new _selector["default"](opts);
  };
  constructors.selector = selector;
  var string = function string2(opts) {
    return new _string["default"](opts);
  };
  constructors.string = string;
  var tag = function tag2(opts) {
    return new _tag["default"](opts);
  };
  constructors.tag = tag;
  var universal = function universal2(opts) {
    return new _universal["default"](opts);
  };
  constructors.universal = universal;
  return constructors;
}
export {
  requireConstructors as __require
};
//# sourceMappingURL=constructors.js.map
